module.exports = __webpack_public_path__ + "img/bingo_ball-35.fd221f15.png";